type HttpErrorShape = {
  response?: { status?: number };
};

/**
 * True when a project detail/list fetch failed as HTTP 403 — a revoked
 * grant (B5), not a missing thread. Duck-typed so `/contracts` stays
 * axios-free; AxiosError matches this shape.
 */
export const isProjectQueryForbidden = (error: unknown): boolean =>
  typeof error === 'object' &&
  error !== null &&
  (error as HttpErrorShape).response?.status === 403;
